export default class DtoKeyFigure {
    constructor(obj) {
        this.value = obj.value
        this.title = obj.title
    }
}